import { lazy } from 'react';
import { Routes } from './utils/renderRoutes';

const exchangeRoutes: Routes[] = [
    {
        title: '兑换管理',
        path: '/exchange',
        component: lazy(() => import('@/views/Exchange')),
    },
];
export default exchangeRoutes;